import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-1 items-center relative text-inbox-gray-theme-600" }

import { ShortMessage } from '@/inbox/composition';
import { SvgIcon } from '@/ui-kit';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShortMessageIcons',
  props: {
    message: null
  },
  setup(__props: any) {

const props = __props as {
	message: ShortMessage;
};



function defineIconComponent() {
	switch (props.message.type) {
		case 'email':
			return 'EmailIcon';
		case 'fax':
			return 'FaxIcon';
		case 'text-message':
			return 'SMSIcon';
		case 'physical-mail':
			return 'MailboxIcon';
		case 'call':
			return props.message.content.records?.[0]
				?.type === 'voicemail'
				? 'VoicemailIcon'
				: 'CallStartIcon';
	}
}

const iconComponent = computed(() => defineIconComponent());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SvgIcon), {
      class: "h-4 w-4",
      name: _unref(iconComponent)
    }, null, 8, ["name"])
  ]))
}
}

})